"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = exports.prop = exports.path = exports.nth = exports.map = exports.last = exports.head = exports.findLast = exports.find = exports.safeGet = exports.safeNth = exports.safeLast = exports.safeFindLast = exports.safeFind = exports.safeMap = exports.safeProps = exports.safeHead = exports.safePath = exports.safeProp = void 0;
/* eslint-disable functional/no-conditional-statement */
const monet_1 = require("monet");
const find_1 = __importDefault(require("ramda/src/find"));
const findLast_1 = __importDefault(require("ramda/src/findLast"));
const head_1 = __importDefault(require("ramda/src/head"));
const last_1 = __importDefault(require("ramda/src/last"));
const nth_1 = __importDefault(require("ramda/src/nth"));
const path_1 = __importDefault(require("ramda/src/path"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const props_1 = __importDefault(require("ramda/src/props"));
const { None, fromNull } = monet_1.Maybe;
function safeProp(key, x) {
    return arguments.length === 2
        ? fromNull(prop_1.default(key, x || {}))
        : (y) => fromNull(prop_1.default(key, y || {}));
}
exports.safeProp = safeProp;
function safePath(safePath, x) {
    return arguments.length === 2
        ? fromNull(path_1.default(safePath, x || {}))
        : (y) => fromNull(path_1.default(safePath, y || {}));
}
exports.safePath = safePath;
/**
 * [a] -> Maybe a
 * @example
 * safeHead([ 1 ]) // => Just(1)
 * @example
 * safeHead([]) // => None
 * @example
 * safeHead() // => None
 */
const safeHead = (array) => Array.isArray(array)
    ? fromNull(head_1.default(array))
    : None();
exports.safeHead = safeHead;
function safeProps(keys, x) {
    return arguments.length === 2
        ? props_1.default(keys, x || {}).map(fromNull)
        : (y) => props_1.default(keys, y || {}).map(fromNull);
}
exports.safeProps = safeProps;
function __map(fn, val) {
    if (!val) {
        return None();
    }
    if (monet_1.Maybe.isInstance(val)) {
        return val.map(fn);
    }
    return monet_1.Just(val.map(fn));
}
function safeMap(fn, val) {
    return arguments.length === 2
        ? __map(fn, val)
        : (y) => __map(fn, y);
}
exports.safeMap = safeMap;
function safeFind(fn, x) {
    return arguments.length === 2
        ? fromNull(find_1.default(fn, x || []))
        : (y) => fromNull(find_1.default(fn, y || []));
}
exports.safeFind = safeFind;
function safeFindLast(fn, x) {
    return arguments.length === 2
        ? fromNull(findLast_1.default(fn, x || []))
        : (y) => fromNull(findLast_1.default(fn, y || []));
}
exports.safeFindLast = safeFindLast;
/**
 * [a] -> Maybe a
 * @example
 * safeLast([ 'one', 'two' ]) // => Just(2)
 * @example
 * safeLast([]) // => None
 */
function safeLast(array) {
    return Array.isArray(array)
        ? fromNull(last_1.default(array))
        : None();
}
exports.safeLast = safeLast;
function safeNth(n, x) {
    return arguments.length === 2
        ? fromNull(nth_1.default(n, x || []))
        : (y) => fromNull(nth_1.default(n, y || []));
}
exports.safeNth = safeNth;
function safeGet(key, map) {
    return arguments.length === 2
        ? monet_1.Maybe.fromUndefined(map ? map.get(key) : undefined)
        : (_map) => monet_1.Maybe.fromUndefined(_map.get(key));
}
exports.safeGet = safeGet;
/** @deprecated import safeFind instead */
exports.find = safeFind;
/** @deprecated import safeFindLast instead */
exports.findLast = safeFindLast;
/** @deprecated import safeHead instead */
exports.head = exports.safeHead;
/** @deprecated import safeLast instead */
exports.last = safeLast;
/** @deprecated import safeMap instead */
exports.map = safeMap;
/** @deprecated import safeNth instead */
exports.nth = safeNth;
/** @deprecated import safePath instead */
exports.path = safePath;
/** @deprecated import safeProp instead */
exports.prop = safeProp;
/** @deprecated import safeProps instead */
exports.props = safeProps;
//# sourceMappingURL=index.js.map